import { render, staticRenderFns } from "./PopupFunction.vue?vue&type=template&id=bf8079ae&scoped=true"
import script from "./PopupFunction.vue?vue&type=script&lang=js"
export * from "./PopupFunction.vue?vue&type=script&lang=js"
import style0 from "./PopupFunction.vue?vue&type=style&index=0&id=bf8079ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8079ae",
  null
  
)

export default component.exports